import { Avatar, Box, Button, Grid2, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Typography } from "@mui/material";
import React, { useState } from "react";
import increment from '../../assets/icons/increment.svg';
import decrement from '../../assets/icons/decrement.svg';
import pendingShipment from '../../assets/images/pendingShipment.svg';
import onGoingShipment from '../../assets/images/onGoingShipment.svg';
import totalShipment from '../../assets/images/totalShipment.svg';
import greenTick from '../../assets/images/greenTickSquare.svg';
import assignedShipment from '../../assets/images/Asssigned.svg';
import unassignedShipment from '../../assets/images/UnassignedCard.svg';
import newUser from '../../assets/icons/newUserIcon.svg';
import foulShipment from '../../assets/images/FoulTripCard.svg';
import cancelledShipment from '../../assets/images/CancelledCard.svg';
import totalDrivers from '../../assets/images/totalDriversCard.svg';
import { TabPanel } from "@mui/lab";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { makeGetRequestToUrl } from "../commonFunc.jsx";
import { BarChart } from "@mui/x-charts";
import config from '../../config/config.js';
import dayjs from 'dayjs';
import { useTheme } from '@mui/material/styles';
import prevIcon from '../../assets/icons/left-arrow.svg'
import nextIcon from '../../assets/icons/right-arrow.svg';
import { useNavigate } from "react-router-dom";

const TmsDashboard = () => {

    const theme = useTheme();
    const serverUrl = config.serverUrl;
    const navigate = useNavigate();
    const currentDate = dayjs(); // Get the current date
    const sevenDayBefore = currentDate.subtract(7, 'day');
    const [driverStatsVal, setDriverStatsVal] = useState("1");
    const [bookingStatsVal, setBookingStatsVal] = useState("1");
    const [headerPeriod, setHeaderPeriod] = useState(1); 
    const [headerData, setHeaderData] = useState([]);
    const [chartData, setChartData] = useState(null);
    const [bookingChartData, setBookingChartData] = useState(null);

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('vehicleName');
    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paginatedData, setPaginatedData] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [tokenExpired, setTokenExpired] = useState(false);
    const bookingStatusMap = {
        "1": "Unassigned",
        "2": "Assigned",
        "3": "Ongoing",
        "4": "Delivered",
        "5": "Cancelled",
        "6": "Foul Trips"
    };

    const handleInputChange = (e) => {
        setHeaderPeriod(e.target.value);
    };

    const driverStaticsValue = (text) => {
        setDriverStatsVal(text);
    }

    const bookingStaticsValue = (text) => {
        setBookingStatsVal(text);
    }

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    React.useEffect(() => {
        const paginated = Array.isArray(rows)
            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : [];
        setPaginatedData(paginated);
    }, [rows, page, rowsPerPage]);
    

    React.useEffect(() => {
        const fetchCarDetailsData = async () => {
            try {
                const token = localStorage.getItem('token');
                const timestamp = new Date().getTime();

                const url = `${serverUrl}/transport/fetch_card_details`;
                const obj={
                    token: token, timestamp: timestamp, period: headerPeriod
                }

                const response =  await makeGetRequestToUrl(url, obj);

                if(response.flag == 200 && response.data){
                    setHeaderData(response.data.cardDetails);
                }
                else if(response.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                    // navigate('/signup');
                }
                else {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchCarDetailsData();
    }, [headerPeriod]);



    React.useEffect(() => {
        const fetchUserStatisticsData = async () => {
            try {
                const token = localStorage.getItem('token');
                const timestamp = new Date().getTime();

                const url = `${serverUrl}/transport/fetch_driver_statistics`;
                const obj={
                    token: token, timestamp: timestamp, period: driverStatsVal
                }

                const response =  await makeGetRequestToUrl(url, obj);

                if(response.flag == 200 && response.data){
                    const userStatisticsData = response.data.driverStatistics;

                    // Use Object.keys for days (x-axis labels)
                    const labels = Object.keys(userStatisticsData); // ['Mon', 'Tues', ...]

                    // Use Object.values for data array (values for each day)
                    const labelsData = Object.values(userStatisticsData); // [{ total: ..., active: ... }, ...]

                    // Extract data series for each metric (e.g., total, active, etc.)
                    const metricKeys = Object.keys(labelsData[0]); // ['total', 'active', 'inactive', 'new_onboard']

                    const formattedSeriesData = metricKeys.map(metric => ({
                        name: metric,
                        data: labels.map(day => userStatisticsData[day][metric]) // Map values for each day
                    }));

                    // Set chart data
                    setChartData({
                        labels: labels, // Use dynamic labels as needed
                        seriesData: formattedSeriesData
                    });
                }
                else if(response.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                }
                else {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchUserStatisticsData();
    }, [driverStatsVal]);

    React.useEffect(() => {
        const fetchBookingStatisticsData = async () => {
            try {
                const token = localStorage.getItem('token');
                const timestamp = new Date().getTime();

                const url = `${serverUrl}/transport/fetch_booking_statistics`;
                const obj={
                    token: token, timestamp: timestamp, period: bookingStatsVal
                }

                const response =  await makeGetRequestToUrl(url, obj);

                if(response.flag == 200 && response.data){
                    const userStatisticsData = response.data.bookingStatistics;

                    // Use Object.keys for days (x-axis labels)
                    const labels = Object.keys(userStatisticsData); // ['Mon', 'Tues', ...]

                    // Use Object.values for data array (values for each day)
                    const labelsData = Object.values(userStatisticsData); // [{ total: ..., active: ... }, ...]

                    // Extract data series for each metric (e.g., total, active, etc.)
                    const metricKeys = Object.keys(labelsData[0]); // ['total', 'active', 'inactive', 'new_onboard']

                    const formattedSeriesData = metricKeys.map(metric => ({
                        name: metric,
                        data: labels.map(day => userStatisticsData[day][metric]) // Map values for each day
                    }));

                    // Set chart data
                    setBookingChartData({
                        labels: labels, // Use dynamic labels as needed
                        seriesData: formattedSeriesData
                    });
                }
                else if(response.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                }
                else {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchBookingStatisticsData();
    }, [bookingStatsVal]);

    const fetchBookingsData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_bookings';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp
            };

            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // Sort data in descending order by booking_id
                const sortedData = [...response.data].sort((a, b) => {
                    // Convert to numbers to ensure proper numeric sorting
                    const bookingIdA = parseInt(a.booking_id);
                    const bookingIdB = parseInt(b.booking_id);
                    return bookingIdB - bookingIdA; // Descending order
                });
                
                setRows(sortedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    React.useEffect(() => {
        fetchBookingsData();
    }, []);

    return(
        <div>
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Dashboard</Typography>

            <Grid2 className="mainBox" sx={{marginTop:'1%'}}>
                <Grid2 item>
                    <select style={{minWidth:'180px', padding:'1%', borderRadius:'10px'}} value={headerPeriod} onChange={handleInputChange}>
                        <option value="1">Today</option>
                        <option value="2">Last 7 Days</option>
                        <option value="3">Last 30 Days</option>
                    </select>
                </Grid2>

                {/* Horizontal Scroll Container */}
                <Grid2
                    container
                    sx={{
                        marginTop: '1%',
                        display: 'grid',
                        gridTemplateColumns: 'repeat(4, 1fr)', // 4 cards per row
                        gap: '20px', // Space between cards
                    }}
                >
                    {/* Card 1: Total Shipment */}
                    <Grid2 item sx={{backgroundColor: '#F3F8FF',padding: '3%',borderRadius: '12px',minHeight: '150px'}}>
                        <img src={totalShipment} alt="totalShipment" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Total Bookings</Typography>
                        {headerData?.TOTAL_BOOKINGS && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.TOTAL_BOOKINGS?.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.TOTAL_BOOKINGS?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.TOTAL_BOOKINGS && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.TOTAL_BOOKINGS.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.TOTAL_BOOKINGS.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Unassigned Shipment Card */}
                    <Grid2 item sx={{backgroundColor: '#EEEEEEB2',padding: '3%',borderRadius: '12px',minHeight: '150px'}}>
                        <img src={unassignedShipment} alt="Active Rides Icon" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Unassigned</Typography>
                        {headerData?.UNASSIGNED_BOOKINGS && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.DELIVERED_BOOKINGS?.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.UNASSIGNED_BOOKINGS?.change >= 0 ? (
                                <img src={increment} alt="Increment Icon" />
                            ) : (
                                <img src={decrement} alt="Decrement Icon" />
                            )}
                            {headerData?.UNASSIGNED_BOOKINGS && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.UNASSIGNED_BOOKINGS.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.UNASSIGNED_BOOKINGS.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Assigned Shipment Card */}
                    <Grid2 item sx={{backgroundColor: '#E0FAFFB2',padding: '3%',borderRadius: '12px',minHeight: '150px'}}>
                        <img src={assignedShipment} alt="pendingShipment" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Assigned</Typography>
                        {headerData?.ASSIGNED_BOOKINGS && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.ASSIGNED_BOOKINGS?.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.ASSIGNED_BOOKINGS?.change >= 0 ? (
                                <img src={increment} alt="Increment Icon" />
                            ) : (
                                <img src={decrement} alt="Decrement Icon" />
                            )}
                            {headerData?.ASSIGNED_BOOKINGS && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.ASSIGNED_BOOKINGS.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.ASSIGNED_BOOKINGS.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Card 2: Ongoing Shipment */}
                    <Grid2 item sx={{backgroundColor: '#FFF7D4B2',padding: '3%',borderRadius: '12px',minHeight: '150px'}}>
                        <img src={onGoingShipment} alt="onGoingShipment" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Ongoing</Typography>
                        {headerData?.ONGOING_BOOKINGS && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.ONGOING_BOOKINGS?.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.ONGOING_BOOKINGS?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.ONGOING_BOOKINGS && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.ONGOING_BOOKINGS.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.ONGOING_BOOKINGS.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Card 1: Delivered Shipment */}
                    <Grid2 item sx={{backgroundColor: '#DFFFE2B2',padding: '3%',borderRadius: '12px',minHeight: '150px'}}>
                        <img src={greenTick} alt="totalShipment" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Delivered</Typography>
                        {headerData?.DELIVERED_BOOKINGS && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.DELIVERED_BOOKINGS?.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.DELIVERED_BOOKINGS?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.DELIVERED_BOOKINGS && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.DELIVERED_BOOKINGS.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.DELIVERED_BOOKINGS.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Card 2: Cancelled Shipment */}
                    <Grid2 item sx={{backgroundColor: '#FFDDDDB2',padding: '3%',borderRadius: '12px',minHeight: '150px'}}>
                        <img src={cancelledShipment} alt="onGoingShipment" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Cancelled</Typography>
                        {headerData?.CANCELLED_BOOKINGS && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.CANCELLED_BOOKINGS?.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.CANCELLED_BOOKINGS?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.CANCELLED_BOOKINGS && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.CANCELLED_BOOKINGS.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.CANCELLED_BOOKINGS.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Foul Shipment Card */}
                    <Grid2 item sx={{backgroundColor: '#FFEBE6B2',padding: '3%',borderRadius: '12px',minHeight: '150px'}}>
                        <img src={pendingShipment} alt="pendingShipment" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Foul Trips</Typography>
                        {headerData?.FOUL_BOOKINGS && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.FOUL_BOOKINGS?.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.FOUL_BOOKINGS?.change >= 0 ? (
                                <img src={increment} alt="Increment Icon" />
                            ) : (
                                <img src={decrement} alt="Decrement Icon" />
                            )}
                            {headerData?.FOUL_BOOKINGS && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.FOUL_BOOKINGS.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.FOUL_BOOKINGS.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Total Drivers Card */}
                    <Grid2 item sx={{backgroundColor: '#EAE6FFB2',padding: '3%',borderRadius: '12px',minHeight: '150px'}}>
                        <img src={totalDrivers} alt="Active Rides Icon" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Total Drivers</Typography>
                        {headerData?.TOTAL_DRIVERS && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.TOTAL_DRIVERS?.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.TOTAL_DRIVERS?.change >= 0 ? (
                                <img src={increment} alt="Increment Icon" />
                            ) : (
                                <img src={decrement} alt="Decrement Icon" />
                            )}
                            {headerData?.TOTAL_DRIVERS && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.TOTAL_DRIVERS.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.TOTAL_DRIVERS.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                </Grid2>
            </Grid2>

            <Grid2 className="mainBox" sx={{marginTop:'1%'}}>
                <Grid2 item>
                    <Typography sx={{fontSize:'24px', color:'#1A1E25', paddingTop:'1%'}}>Driver's Statistics</Typography>
                </Grid2>
                <hr/>

                {/* <Grid2> */}
                    <Grid2 item>

                        <Grid2 container>
                            <Grid2 item sx={{marginLeft:'auto'}}>
                                <Button className = {`daysWeeklyMonthly ${driverStatsVal === '1' ? 'active' : ''}`}
                                onClick={()=>driverStaticsValue('1')}>Days</Button>

                                <Button className={`daysWeeklyMonthly ${driverStatsVal === '2' ? 'active' : ''}`} 
                                onClick={()=>driverStaticsValue('2')}>Weekly</Button>

                                <Button className={`daysWeeklyMonthly ${driverStatsVal === '3' ? 'active' : ''}`}
                                onClick={()=>driverStaticsValue('3')}>Monthly</Button>
                            </Grid2>
                        </Grid2>

                        <Grid2 dir={theme.direction}>
                            {chartData && (
                                <BarChart
                                    xAxis={[{ scaleType: 'band', data: chartData.labels }]}
                                    series={chartData.seriesData}
                                    width={500}
                                    height={300}
                                />
                            )}
                        </Grid2>

                        <Grid2 container spacing={4} sx={{backgroundColor:'#F9F9F9'}}>
                            <Grid2 item sx={{display:'flex'}}>
                                <Grid2 item>
                                    <FiberManualRecordIcon style={{ fontSize: '16px', color:'#02B2AF' }}/>
                                </Grid2>
                                <Grid2 item>
                                    <Typography sx={{color:'#83888E', fontSize:'14px'}}>Total Drivers</Typography>
                                </Grid2>
                            </Grid2>
                            {/* <Grid2 item sx={{display:'flex'}}>
                                <Grid2 item>
                                    <FiberManualRecordIcon style={{ fontSize: '16px', color:'#2E96FF' }}/>
                                </Grid2>
                                <Grid2 item>
                                    <Typography sx={{color:'#83888E', fontSize:'14px'}}>Active Drivers</Typography>
                                </Grid2>
                            </Grid2> */}
                        </Grid2>
                    </Grid2>
                {/* </Grid2> */}
            </Grid2>

            <Grid2 className="mainBox" sx={{marginTop:'1%'}}>
                <Grid2 item>
                    <Typography sx={{fontSize:'24px', color:'#1A1E25', paddingTop:'1%'}}>Booking's Statistics</Typography>
                </Grid2>
                <hr/>
                <Grid2 item>
                    <Grid2 container>
                        <Grid2 item sx={{marginLeft:'auto'}}>
                            <Button className = {`daysWeeklyMonthly ${bookingStatsVal === '1' ? 'active' : ''}`}
                            onClick={()=>bookingStaticsValue('1')}>Days</Button>

                            <Button className={`daysWeeklyMonthly ${bookingStatsVal === '2' ? 'active' : ''}`} 
                            onClick={()=>bookingStaticsValue('2')}>Weekly</Button>

                            <Button className={`daysWeeklyMonthly ${bookingStatsVal === '3' ? 'active' : ''}`}
                            onClick={()=>bookingStaticsValue('3')}>Monthly</Button>
                        </Grid2>
                    </Grid2>

                    <Grid2 dir={theme.direction}>
                        {bookingChartData && (
                            <BarChart
                                xAxis={[{ scaleType: 'band', data: bookingChartData.labels }]}
                                series={bookingChartData.seriesData}
                                width={500}
                                height={300}
                            />
                        )}
                    </Grid2>

                    <Grid2 container spacing={4} sx={{backgroundColor:'#F9F9F9'}}>
                        <Grid2 item sx={{display:'flex'}}>
                            <Grid2 item>
                                <FiberManualRecordIcon style={{ fontSize: '16px', color:'#02B2AF' }}/>
                            </Grid2>
                            <Grid2 item>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Total Bookings</Typography>
                            </Grid2>
                        </Grid2>
                        <Grid2 item sx={{display:'flex'}}>
                            <Grid2 item>
                                <FiberManualRecordIcon style={{ fontSize: '16px', color:'#2E96FF' }}/>
                            </Grid2>
                            <Grid2 item>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Delivered Bookings</Typography>
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </Grid2>
            </Grid2>

            <Grid2 className="mainBox" sx={{marginTop:'1%'}}>
                <Grid2 item container>
                    <Typography sx={{fontSize:'24px', color:'#1A1E25', paddingTop:'1%'}}>New Bookings</Typography>
                    <Grid2 item onClick={() => navigate('/tms-booking')} sx={{marginLeft:'auto', border:'1px solid #D1D5DB', backgroundColor:'#F9F9F9', borderRadius:'8px', width:'100px', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer'}}>
                        <Typography sx={{color:'#4E545D', fontSize:'16px', padding:'1%', width:'100%', textAlign:'center'}}>View All</Typography>
                    </Grid2>
                </Grid2>
                <hr/>
                <Grid2 item>
                    <Grid2 dir={theme.direction}>
                        <TableContainer className="table-container" sx={{maxHeight:'70vh'}}>
                            <Table stickyHeader className="scrollable-table">
                                <TableHead>
                                    <TableRow>
                                        {/* <TableCell align="center" className="table-header" style={{ width: '15%' }}>Booking ID</TableCell> */}
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <TableSortLabel
                                                active={orderBy === 'booking_id'}
                                                direction={orderBy === 'booking_id' ? order : 'asc'}
                                                onClick={() => handleRequestSort('booking_id')}
                                            >
                                                Booking ID
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <TableSortLabel active={orderBy === 'tms_client_name'} direction={orderBy === 'tms_client_name' ? order : 'asc'}
                                                onClick={() => handleRequestSort('tms_client_name')}>
                                            Client
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <TableSortLabel active={orderBy === 'container_movement_type'} direction={orderBy === 'container_movement_type' ? order : 'asc'}
                                                onClick={() => handleRequestSort('container_movement_type')}>
                                            Type of Movement
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <TableSortLabel active={orderBy === 'container_size'} direction={orderBy === 'container_size' ? order : 'asc'}
                                                onClick={() => handleRequestSort('container_size')}>
                                            Size
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                        <TableSortLabel active={orderBy === 'pickup_address'} direction={orderBy === 'pickup_address' ? order : 'asc'}
                                                onClick={() => handleRequestSort('pickup_address')}>
                                            Source
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <TableSortLabel active={orderBy === 'drop_address'} direction={orderBy === 'drop_address' ? order : 'asc'}
                                                onClick={() => handleRequestSort('drop_address')}>
                                            Destination
                                            </TableSortLabel>
                                        </TableCell>
                                        {/* <TableCell align="center" className="table-header" style={{ width: '15%' }}>Request Delivery</TableCell> */}
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <TableSortLabel active={orderBy === 'booking_status'} direction={orderBy === 'booking_status' ? order : 'asc'}
                                                onClick={() => handleRequestSort('booking_status')}>
                                            Booking Status
                                            </TableSortLabel>
                                        </TableCell>
                                        {/* <TableCell align="center" className="table-header" style={{ width: '15%' }}>Plate No</TableCell> */}
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                        <TableSortLabel active={orderBy === 'pickup_time'} direction={orderBy === 'pickup_time' ? order : 'asc'}
                                                onClick={() => handleRequestSort('pickup_time')}>
                                            Pickup Date
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                        <TableSortLabel active={orderBy === 'drop_time'} direction={orderBy === 'drop_time' ? order : 'asc'}
                                                onClick={() => handleRequestSort('drop_time')}>
                                            Drop Date
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                        <TableSortLabel active={orderBy === 'container_details'} direction={orderBy === 'container_details' ? order : 'asc'}
                                                onClick={() => handleRequestSort('container_details')}>
                                            Container Details
                                            </TableSortLabel>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {rows.length === 0 && (
                                        <TableRow>
                                            <TableCell colSpan={13} align="center">
                                                <Typography variant="body1">No data found</Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {

                                        return(
                                            <TableRow key={row.chasis_id}>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.booking_id}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.tms_client_name}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.container_movement_type}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.container_size}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.pickup_address}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.drop_address}</Typography></TableCell>
                                                {/* <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.chasis_type}</Typography></TableCell> */}
                                                <TableCell align="center">
                                                    <Typography 
                                                        sx={{ 
                                                            width: 'auto', 
                                                            minWidth: '100px',
                                                            color: row?.booking_status === 5 ? '#C71F1F' :
                                                                row?.booking_status === 6 ? '#FF8C00' :
                                                                row?.booking_status === 4 ? '#0DBA78' :
                                                                row?.booking_status === 3 ? '#2196F3' :
                                                                row?.booking_status === 2 ? '#9C27B0' :
                                                                '#757575'
                                                        }}
                                                    >
                                                        {bookingStatusMap[row?.booking_status] || row?.booking_status}
                                                    </Typography>
                                                </TableCell>
                                                {/* <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.address}</Typography></TableCell> */}
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                                    {row.pickup_time ? dayjs(row.pickup_time).format('YYYY-MM-DD HH:mm:ss') : ''}
                                                </Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                                    {row.drop_time ? dayjs(row.drop_time).format('YYYY-MM-DD HH:mm:ss') : ''}
                                                </Typography></TableCell>
                                                <TableCell align="center">
                                                    {row.container_details && typeof row.container_details === 'object' ? (
                                                        <Box sx={{ minWidth: '200px', maxWidth: '250px', padding: '8px', margin: '0 auto' }}>
                                                            {Object.keys(row.container_details).map((key, index) => {
                                                                const container = row.container_details[key];
                                                                return (
                                                                    <Box 
                                                                        key={index} 
                                                                        sx={{ 
                                                                            mb: index < Object.keys(row.container_details).length - 1 ? 1.5 : 0,
                                                                            pb: index < Object.keys(row.container_details).length - 1 ? 1 : 0,
                                                                            borderBottom: index < Object.keys(row.container_details).length - 1 ? '1px dashed #e0e0e0' : 'none'
                                                                        }}
                                                                    >
                                                                        <Typography variant="body2" sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                                                            <span style={{ fontWeight: 600, color: '#555', width: '110px' }}>Number :</span>
                                                                            <span style={{ flex: 1, textAlign: 'left' }}>{container.container_no || 'N/A'}</span>
                                                                        </Typography>
                                                                        <Typography variant="body2" sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                                                            <span style={{ fontWeight: 600, color: '#555', width: '110px' }}>Condition :</span>
                                                                            <span style={{ flex: 1, textAlign: 'left' }}>{container.container_condition || 'N/A'}</span>
                                                                        </Typography>
                                                                        <Typography variant="body2" sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                            <span style={{ fontWeight: 600, color: '#555', width: '110px' }}>Size :</span>
                                                                            <span style={{ flex: 1, textAlign: 'left' }}>{container.container_size_value || 'N/A'}</span>
                                                                        </Typography>
                                                                    </Box>
                                                                );
                                                            })}
                                                        </Box>
                                                    ) : (
                                                        <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                                            {typeof row.container_details === 'string' ? row.container_details : 'No container details'}
                                                        </Typography>
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>

                            <div className="custom-pagination">
                                <div className="pagination-info">
                                    {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                                        (page + 1) * rowsPerPage,
                                        rows.length
                                    )} of ${rows.length} entries`}
                                </div>
                                <div className="pagination-controls">
                                <button
                                    onClick={() => handleChangePage(null, page - 1)}
                                    disabled={page === 0}
                                    className="pagination-arrow"
                                >
                                    <img src={prevIcon} alt="Previous" />
                                </button>
                                    <div className="pagination-numbers">
                                        {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                            <button key={index} onClick={() => handleChangePage(null, index)}
                                                className={`pagination-number ${ page === index ? 'active' : ''}`}>
                                                {index + 1}
                                            </button>
                                        ))}
                                    </div>
                                    <button
                                        onClick={() => handleChangePage(null, page + 1)}
                                        disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                                        className="pagination-arrow"
                                    >
                                        <img src={nextIcon} alt="Next" />
                                    </button>
                                </div>
                            </div>
                        </TableContainer>
                    </Grid2>
                </Grid2>
            </Grid2>
        </div>
    )
}

export default TmsDashboard;